/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import NavbarLangOnly from "../../components/Home/navbarLang/NavbarLangOnly";
import { ToastContainer } from "react-toastify";
import ResetPasswordUI from "./ResetPasswordUI";
import useResetPassword from "./useResetPassword";

export default function ResetPassword() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const logic = useResetPassword(isArabic);

  return (
    <>
      <NavbarLangOnly />
      <ToastContainer />
      <ResetPasswordUI isArabic={isArabic} {...logic} />
    </>
  );
}
